import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import { TextField } from 'components/mui';
import { CustomerType } from 'containers/pages/customers/types';

interface CustomerTypeSelectorProps {
  value: number | null;
  customerTypes: CustomerType[];
  onChange: (event: unknown, newValue: CustomerType | null) => void;
  error?: boolean;
  helperText?: string;
}

function CustomerTypeSelector({
  value,
  customerTypes,
  onChange,
  error = false,
  helperText = '',
}: CustomerTypeSelectorProps) {
  const selectedOption = customerTypes.find((t) => t.Id === value) || null;

  return (
    <Autocomplete
      value={selectedOption}
      options={customerTypes}
      getOptionLabel={(option) => option.Title || ''}
      isOptionEqualToValue={(option, val) => option.Id === val.Id}
      onChange={onChange}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Customer Type"
          required
          error={error}
          helperText={helperText}
          size="small"
        />
      )}
      size="small"
      fullWidth
    />
  );
}

export default CustomerTypeSelector;
